module.exports = __webpack_public_path__ + "static/img/index17.aeb3b08.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index17.gif
// module id = gDkE
// module chunks = 0